import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft, FileText } from 'lucide-react';
import Footer from '@/components/Footer';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TermsConditionsPage = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTermsConditions();
  }, []);

  const fetchTermsConditions = async () => {
    try {
      const response = await axios.get(`${API}/cms/policies`);
      setContent(response.data.terms_conditions || 'Terms & Conditions content not yet configured.');
    } catch (error) {
      console.error('Failed to fetch terms & conditions:', error);
      setContent('Failed to load terms & conditions. Please try again later.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Card className="p-8">
          {/* Header */}
          <div className="mb-8">
            <Button 
              variant="outline" 
              onClick={() => navigate('/')}
              className="mb-4"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
            
            <div className="flex items-center space-x-3">
              <FileText className="w-10 h-10 text-[#0056B3]" />
              <h1 className="text-2xl font-bold text-gray-900">Terms & Conditions</h1>
            </div>
            <p className="text-gray-600 mt-2">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>

          {/* Content */}
          <div className="prose max-w-none">
            {loading ? (
              <div className="text-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
                <p className="text-gray-600 mt-4">Loading terms & conditions...</p>
              </div>
            ) : (
              <div 
                className="text-gray-700 leading-relaxed ql-editor" 
                dangerouslySetInnerHTML={{ __html: content }}
              />
            )}
          </div>
        </Card>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TermsConditionsPage;
